import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';

import MenuButton from '../../MenuButton';
import DesktopMenuContent from './DesktopMenuContent';

const open = keyframes`
  from {
    height: 0;
  }
  to {
    height: 220px;
  }
`;

const close = keyframes`
  from {
    height: 220px;
  }
  to {
    height: 0;
  }
`;

class MenuDesktop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isHidden: true,
            animation: null,
        };

        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.handleAnimationEnd = this.handleAnimationEnd.bind(this);
    }

    onMouseEnter() {
        this.setState({ animation: 'open', isHidden: false });
    }

    onMouseLeave() {
        this.setState({ animation: 'close' });
    }

    handleAnimationEnd() {
        const { animation } = this.state;

        if (animation === 'close') {
            this.setState({ isHidden: true });
        }
    }

    render() {
        const { className, onClick, handleChangePage } = this.props;
        const { isHidden, animation } = this.state;

        return (
            <Root
                className={className}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
            >
                <MenuButtonStyled isHidden={isHidden} onClick={onClick} />
                <DesktopMenuContentStyled
                    animation={animation}
                    onAnimationEnd={this.handleAnimationEnd}
                    handleChangePage={handleChangePage}
                />
            </Root>
        );
    }
}

const Root = styled.div``;

const MenuButtonStyled = styled(MenuButton)``;

const DesktopMenuContentStyled = styled(DesktopMenuContent)`
    height: 0px;
    overflow: hidden;

    animation-name: ${({ animation }) => ((animation === 'open' && open) || (animation === 'close' && close) || 'unset')};
    animation-duration: 0.5s;
    animation-timing-function: ease-out;
    animation-fill-mode: forwards;
`;

export default MenuDesktop;
